export default __webpack_public_path__ + "static/media/possibility.758efb1f.png";